/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Member_RemovedInputs */

const en_msg_member_removed = /** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member has been removed from the community.`)
};

const es_msg_member_removed = /** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El miembro ha sido eliminado de la comunidad.`)
};

const fr_msg_member_removed = /** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le membre a été retiré de la communauté.`)
};

const de_msg_member_removed = /** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Mitglied wurde aus der Community entfernt.`)
};

const id_msg_member_removed = /** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota telah dihapus dari komunitas.`)
};

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const ja_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const zh_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const ar_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const it_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const ru_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const pt_msg_member_removed = en_msg_member_removed;

/** @type {(inputs: Msg_Member_RemovedInputs) => LocalizedString} */
const ko_msg_member_removed = en_msg_member_removed;

/**
* | output |
* | --- |
* | "Member has been removed from the community." |
*
* @param {Msg_Member_RemovedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_member_removed = /** @type {((inputs?: Msg_Member_RemovedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Member_RemovedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_member_removed(inputs)
	if (locale === "es") return es_msg_member_removed(inputs)
	if (locale === "fr") return fr_msg_member_removed(inputs)
	if (locale === "de") return de_msg_member_removed(inputs)
	if (locale === "ja") return ja_msg_member_removed(inputs)
	if (locale === "zh") return zh_msg_member_removed(inputs)
	if (locale === "ar") return ar_msg_member_removed(inputs)
	if (locale === "id") return id_msg_member_removed(inputs)
	if (locale === "it") return it_msg_member_removed(inputs)
	if (locale === "ru") return ru_msg_member_removed(inputs)
	if (locale === "pt") return pt_msg_member_removed(inputs)
	return ko_msg_member_removed(inputs)
});